import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppRoute from './AppRoute';
import { usePageTracking } from '../hooks/usePageTracking';

// Layouts
import { HomeLayout } from '../layouts/Website/home/HomeLayout';
import { WebSiteLayout } from '../layouts/Website/WebSiteLayout';
import { WebSiteLayout2 } from '../layouts/Website/WebsiteLayout2';
import { EventsLayout } from '../layouts/Website/events/EventsLayout';
import { NeutralLayout } from '../layouts/Website/NeutralLayout';

// Website Core
import Home from '../views/website/home';
import ForBusiness from '../views/website/ForBusiness';
import ForPeople from '../views/website/forPeople';
import MerchantServices from '../views/website/MerchantServices';
import Search from '../views/website/search';

// Auth
import SelectUserType from '../views/auth/selectUserType';
import PersonSignUp from '../views/auth/signUp_person';
import CompanySignUp from '../views/auth/signUp_company';
import SignIn from '../views/auth/signIn';
import ForgotPassword from '../views/auth/forgotPassword';
import EmailVerification from '../views/auth/emailVerification';
import CompleteProfile from '../views/auth/CompleteProfile';

// Merchants & Places
import Merchants from '../views/website/merchants';
import MerchantSelect from '../views/website/merchants/select';
import PublicMerchantProfile from '../views/website/merchants/PublicMerchantProfile';
import MerchantMenu from '../views/website/merchants/menu';
import MerchantMenuProducts from '../views/website/merchants/menuProducts';
import MerchantReview from '../views/website/merchants/review';
import BusinessCardV2 from '../views/website/merchants/BusinessCardV2';

// Events
import Events from '../views/website/events';
import EventsDetails from '../views/website/events/detail';
import EventTickets from '../views/website/events/EventTickets';
import EventsReview from '../views/website/events/review';
import Ticket from '../views/client/events/ticket';

// Legal & Help
import Privacy from '../views/legal/privacy';
import TermsAndConditions from '../views/legal/terms';
import DeleteUser from '../views/legal/deleteUser';
import HelpLandingView from '../views/website/help/HelpLandingView';
import HelpRequestPublicView from '../views/website/help/HelpRequestPublicView';
import HelpTransparencyView from '../views/website/help/HelpTransparencyView';

export default function WebSiteNavigation() {
    usePageTracking();
    
    return(
        <Switch>
            <AppRoute exact path='/' layout={HomeLayout} component={Home} />

            {/** Parte informativa */}
            <AppRoute exact path='/merchants/services' layout={HomeLayout} component={MerchantServices} />
            <AppRoute exact path='/forpeople' layout={HomeLayout} component={ForPeople} />

            {/** AUTH */}
            <AppRoute exact path='/auth/userType' layout={HomeLayout} component={SelectUserType} />
            <AppRoute path='/auth/personSignUp' layout={HomeLayout} component={PersonSignUp} />
            <AppRoute path='/auth/merchantSignUp' layout={HomeLayout} component={CompanySignUp} />
            <AppRoute path='/auth/signIn' layout={HomeLayout} component={SignIn} />
            <AppRoute path='/auth/forgotPassword' layout={HomeLayout} component={ForgotPassword} />
            <AppRoute path='/auth/verify/:email/:code' layout={WebSiteLayout} component={EmailVerification} />
            <AppRoute path='/auth/complete/profile/:uuid' layout={WebSiteLayout} component={CompleteProfile} />

            {/** Search */}
            <AppRoute exact path='/search/:category/:location?' layout={HomeLayout} component={Search} />

            {/** Merchants */}
            {/* NOTA: Eliminé un duplicado exacto de '/merchants' que apuntaba a ForBusiness */}
            <AppRoute exact path='/merchants' layout={HomeLayout} component={ForBusiness} />
            <AppRoute exact path='/merchants/:uuid' layout={HomeLayout} component={MerchantSelect} />
            <AppRoute exact path='/merchants/:uuid/review' layout={HomeLayout} component={MerchantReview} />

            {/* NUEVAS RUTAS (Simétricas con tu App Móvil) */}
            <AppRoute exact path='/places/:uuid' layout={EventsLayout} component={PublicMerchantProfile} />
            <AppRoute exact path='/places/:uuid/catalog' layout={HomeLayout} component={MerchantMenu} />
            <AppRoute exact path='/places/:uuid/catalog/:category_uuid' layout={HomeLayout} component={MerchantMenuProducts} />

            {/** Events */}
            <AppRoute exact path='/events' layout={EventsLayout} component={Events} />
            <AppRoute exact path='/events/:id' layout={WebSiteLayout2} component={EventsDetails} />
            <AppRoute exact path='/events/:id/tickets' layout={WebSiteLayout2} component={EventTickets} />
            <AppRoute exact path='/events/:id/review' layout={WebSiteLayout2} component={EventsReview} />

            <AppRoute exact path='/ticketing/:uuid' layout={WebSiteLayout2} component={Ticket} />

            {/* SALVAVIDAS SEO Y QR (Redirecciones de las rutas viejas) */}
            {/* Redirecciones de Comercios */}
            <Redirect exact from="/merchants/:uuid/menu/:category_uuid" to="/places/:uuid/catalog/:category_uuid" />
            <Redirect exact from="/merchants/:uuid/profile" to="/places/:uuid" />
            <Redirect exact from="/merchants/:uuid/menu" to="/places/:uuid/catalog" />
            <Redirect exact from="/merchants/:uuid" to="/places/:uuid" />

            {/* Redirecciones de Eventos */}
            <Redirect exact from="/eventos/:id/tickets" to="/events/:id/tickets" />
            <Redirect exact from="/eventos/:id/review" to="/events/:id/review" />
            <Redirect exact from="/eventos/:id" to="/events/:id" />
            <Redirect exact from="/eventos" to="/events" />

            {/** Business Cards */}
            <AppRoute exact path='/businesscard/:uuid' layout={NeutralLayout} component={BusinessCardV2} />

            {/** Legal & Help */}
            <AppRoute exact path='/privacy' layout={WebSiteLayout2} component={Privacy} />
            <AppRoute exact path='/termsandconditions' layout={WebSiteLayout2} component={TermsAndConditions} />
            <AppRoute exact path='/deleteUser' layout={WebSiteLayout2} component={DeleteUser} />
            
            
            <AppRoute exact path='/sos' layout={WebSiteLayout} component={HelpLandingView} />
            <AppRoute exact path='/sos-solicitud' layout={WebSiteLayout2} component={HelpRequestPublicView} />
            <AppRoute exact path='/sos-transparencia' layout={WebSiteLayout2} component={HelpTransparencyView} />

            {/** Para las rutas no encontradas */}
            <Route path="*">
                <Redirect to="/"/>
            </Route>
        </Switch>
    )
}